<template>
  <div class="dropdown-list">
    <div class="dropdown-list-header">
      <div class="dropdown-list-title">{{ title }}</div>
      <dim-picker
        v-if="hasAdd"
        :disabled="!canAdd"
        :dimensions="otherDims"
        :max-items="maxItems"
        @select="(dim)=>$emit('add',dim)"
      />
    </div>
    <slot name="list" />
  </div>
</template>

<script>
import DimPicker from './DimPicker.vue'
export default {
  components: { DimPicker },
  props: ['title', 'canAdd', 'hasAdd', 'otherDims', 'maxItems'],
}
</script>

<style lang="stylus" scoped>
.dropdown-list
  padding: vw(10px) vw(20px)

  >>> .filter
    &:not(:last-child)
      margin-bottom: vw(10px)

.dropdown-list-header
  display: flex
  justify-content: space-between
  align-items: center
  margin-bottom: vw(10px)

.dropdown-list-title
  // m-first-letter-case()
  m-font-size(14, 20)
  color: $grey
  font-weight: 600
</style>
